module.exports = __webpack_public_path__ + "img/Reihenhaus.972452de.svg";